module.exports = __webpack_public_path__ + "static/media/image_3.85b8aea6.jpg";